// @flow

import type {
  Operation,
  ActionCreators,
  OperationAction,
  OperationsAction,
  // OperationError,
} from '../types'

import {
  addOperation,
  editOperation,
  deleteOperation,
  readOperation,
} from './utils'

import composeActionTypes from './composeActionTypes'

type Args = {
  model: string,
}

export default function composeActionCreators<T: Object> ({
  model: modelName,
  }: Args): ActionCreators<T> {
  const actionTypes = composeActionTypes({model: modelName})

  return {
    add: function (...args: Array<Operation<T>>): OperationsAction<T> {
      return {
        type: actionTypes.add(),
        payload: args.map(addOperation),
      }
    },
    edit: function (...args: Array<Operation<T>>): OperationsAction<T> {
      return {
        type: actionTypes.edit(),
        payload: args.map(editOperation),
      }
    },
    delete: function (...args: Array<Operation<T>>): OperationsAction<T> {
      return {
        type: actionTypes.delete(),
        payload: args.map(deleteOperation),
      }
    },
    read: function (...args: Array<Operation<T>>): OperationsAction<T> {
      return {
        type: actionTypes.read(),
        payload: args.map(readOperation),
      }
    },
    updateOperation: function (payload: Operation<T>): OperationAction<T> {
      return {
        type: actionTypes.updateOperation(),
        payload,
      }
    },
    updateOperations: function (payload: Array<Operation<T>>): OperationsAction<T> {
      return {
        type: actionTypes.updateOperations(),
        payload,
      }
    },
    cancelOperation: function (payload: Operation<T>): OperationAction<T> {
      return {
        type: actionTypes.cancelOperation(),
        payload,
      }
    },
    cancelOperations: function (payload: Array<Operation<T>>): OperationsAction<T> {
      return {
        type: actionTypes.cancelOperations(),
        payload,
      }
    },
    submitOperation: function (payload: Operation<T>): OperationAction<T> {
      return {
        type: actionTypes.submitOperation(),
        payload,
      }
    },
    submitOperations: function (payload: Array<Operation<T>>): OperationsAction<T> {
      return {
        type: actionTypes.submitOperations(),
        payload,
      }
    },
  }
}
